"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelativeValue = exports.initializer = exports.dateTimeFilterReducer = exports.DATE_TIME_FILTER_CHANGED = void 0;
const dateTimeUtils_1 = require("./dateTimeUtils");
const utils_1 = require("./utils");
exports.DATE_TIME_FILTER_CHANGED = "DateTimeFilterChanged";
const dateTimeFilterReducer = (state, action) => {
    const { type, payload } = action;
    if (type === exports.DATE_TIME_FILTER_CHANGED) {
        const value = getValue(payload?.value);
        return {
            value,
            absolute: isExpressionValue(value) ? (0, dateTimeUtils_1.resolveDateFromExpression)(value) : null,
            ...getRelative(payload?.value),
        };
    }
    return state;
};
exports.dateTimeFilterReducer = dateTimeFilterReducer;
const initializer = ({ value }) => {
    return isExpressionValue(value)
        ? {
            value: getValue(value),
            absolute: (0, dateTimeUtils_1.resolveDateFromExpression)(value),
            ...getRelative(value),
        }
        : { value, absolute: null, amount: null, unit: null, startOfUnit: false };
};
exports.initializer = initializer;
const getValue = (value) => {
    if (isExpressionValue(value) || isAbsoluteValue(value))
        return value;
    if ((0, exports.isRelativeValue)(value))
        return (0, utils_1.resolveExpressionFromRelativeDateTime)(value);
    return null;
};
const getRelative = (value) => {
    if (!value || isAbsoluteValue(value))
        return { amount: null, unit: null, startOfUnit: false };
    if (isExpressionValue(value)) {
        const relative = (0, dateTimeUtils_1.resolveRelativeDateTimeFromExpression)(value);
        const relativeValue = Array.isArray(relative) || !relative ? null : relative; // array indicates multiple temporalFunctions e.g now - 2 days - 2 hours which cannot be mapped to relative inputs. Only - 2 days would be supported.
        return {
            amount: relativeValue?.amount?.replace("-", ""),
            unit: (0, utils_1.temporalFunctionToRelativeUnit)(relativeValue?.temporalFunction, relativeValue?.amount?.includes("-")),
            startOfUnit: ["startofday", "startofweek", "startofmonth", "startofyear"]?.includes(relativeValue?.initialFunction?.toLowerCase()),
        };
    }
    return { amount: value?.amount || null, unit: value?.unit || null, startOfUnit: value?.startOfUnit || false };
};
const isAbsoluteValue = (payload) => {
    return typeof payload === "number";
};
const isExpressionValue = (payload) => {
    return typeof payload === "string";
};
const isRelativeValue = (value) => {
    const internalValue = value;
    if (!internalValue)
        return false;
    return Boolean(internalValue?.expression || internalValue?.amount || internalValue?.unit);
};
exports.isRelativeValue = isRelativeValue;
